










































import { defineComponent, ref, watch, computed } from '@vue/composition-api';
import { LocationType } from '@/types/utils';
import { useFindStore } from '@/features/branches';

// components
import SvgIcon from '@/components/SvgIcon.vue';
import AppButton from '@/components/AppButton.vue';
import StaticMap from '@/components/StaticMap.vue';
import MapSearch from '@/components/MapSearch.vue';

export default defineComponent({
  name: 'JumpstartChooseLocation',
  components: {
    SvgIcon,
    AppButton,
    StaticMap,
    MapSearch,
    ModalDialog: () => import('@/components/ModalDialog.vue'),
    JumpstartSelectedLocation: () => import('@/components/Jumpstart/SelectedLocation.vue'),
  },
  setup(_, { emit }) {
    const isOpen = ref(false);
    const location = ref<LocationType>();
    const selectedLocation = ref<LocationType | null>();
    const mapLoaded = ref(false);
    const place = ref<Record<string, any>>();

    // Variables for find store hook
    const variables = computed(() => {
      return {
        lat: String(location.value?.lat),
        lng: String(location.value?.lng),
      };
    });

    // To find store for allowed (lat, lng)
    const { storeId } = useFindStore(variables);

    /**
     * Computed property to determine if the location is unsupported.
     */
    const unSupportedLocation = computed(() => {
      return !storeId.value;
    });

    // On map load CTA
    const onMapLoadAction = () => {
      mapLoaded.value = true;
    };

    // watch place change value from search map CTA
    watch(place, value => {
      location.value = {
        lat: Number(value?.geometry?.location?.lat()),
        lng: Number(value?.geometry?.location?.lng()),
      };
    });

    /**
     * Function to remove the selected location.
     */
    const onRemoveLocation = () => {
      selectedLocation.value = null;
      emit('change', null);
    };

    /**
     * Function to reset the location.
     */
    const onResetLocation = () => {
      isOpen.value = true;
    };

    // On select location CTA
    const onSelectLocation = () => {
      isOpen.value = false;
      selectedLocation.value = location.value;
      emit('change', { location: location.value, storeId: storeId.value });
    };

    return {
      isOpen,
      location,
      mapLoaded,
      onMapLoadAction,
      onSelectLocation,
      place,
      unSupportedLocation,
      selectedLocation,
      onRemoveLocation,
      onResetLocation,
    };
  },
});
